import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";

const TEXT = {
    vipLevel: "Cấp VIP",
    multiple: "Vòng cược trước khi rút",
}

const SetupScore = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [vipNew, setVipNew] = useState();
    const [vipSilver, setVipSilver] = useState();
    const [vipPlatinum, setVipPlatinum] = useState();
    const [vipSappphire, setVipSappphire] = useState();
    const [multiple, setMultiple] = useState();

    const [top1, setTop1] = useState();
    const [top2, setTop2] = useState();
    const [top3, setTop3] = useState();
    const [top4, setTop4] = useState();
    const [top5, setTop5] = useState();
    const [top6, setTop6] = useState();
    const [top7, setTop7] = useState();
    const [top8, setTop8] = useState();
    const [top9, setTop9] = useState();
    const [top10, setTop10] = useState();
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getDataConfig();
    }, []);

    const getDataConfig = async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data?.data ?? res.data;
            const loadedMultiple =
                data?.multiple !== undefined && data?.multiple !== null && data?.multiple !== ""
                    ? Number(data.multiple)
                    : undefined;

            setConfigGame({
                vipNew: data?.vipLevels["NEW"],
                vipSilver: data?.vipLevels["SILVER"],
                vipPlatinum: data?.vipLevels["PLATINUM"],
                vipSappphire: data?.vipLevels["SAPPHIRE"],
                top1: data?.eventRewards["TOP1"],
                top2: data?.eventRewards["TOP2"],
                top3: data?.eventRewards["TOP3"],
                top4: data?.eventRewards["TOP4"],
                top5: data?.eventRewards["TOP5"],
                top6: data?.eventRewards["TOP6"],
                top7: data?.eventRewards["TOP7"],
                top8: data?.eventRewards["TOP8"],
                top9: data?.eventRewards["TOP9"],
                top10: data?.eventRewards["TOP10"],
                multiple: loadedMultiple,
            });
            setVipNew(data?.vipLevels["NEW"]?.MAX_SCORE);
            setVipSilver(data?.vipLevels["SILVER"]?.MAX_SCORE);
            setVipPlatinum(data?.vipLevels["PLATINUM"]?.MAX_SCORE);
            setVipSappphire(data?.vipLevels["SAPPHIRE"]?.MAX_SCORE);
            setTop1(data?.eventRewards["TOP1"]);
            setTop2(data?.eventRewards["TOP2"]);
            setTop3(data?.eventRewards["TOP3"]);
            setTop4(data?.eventRewards["TOP4"]);
            setTop5(data?.eventRewards["TOP5"]);
            setTop6(data?.eventRewards["TOP6"]);
            setTop7(data?.eventRewards["TOP7"]);
            setTop8(data?.eventRewards["TOP8"]);
            setTop9(data?.eventRewards["TOP9"]);
            setTop10(data?.eventRewards["TOP10"]);
            if (loadedMultiple !== undefined && !Number.isNaN(loadedMultiple)) {
                setMultiple(loadedMultiple);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleChangeInput = (e, key) => {
        switch (key) {
            case 1: setVipNew(e); return;
            case 2: setVipSilver(e); return;
            case 3: setVipPlatinum(e); return;
            case 4: setVipSappphire(e); return;
            case 5: setTop1(e); return;
            case 6: setTop2(e); return;
            case 7: setTop3(e); return;
            case 8: setTop4(e); return;
            case 9: setTop5(e); return;
            case 10: setTop6(e); return;
            case 11: setTop7(e); return;
            case 12: setTop8(e); return;
            case 13: setTop9(e); return;
            case 14: setTop10(e); return;
            default: return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            if (
                !validNumber(vipNew) || !validNumber(vipSilver) ||
                !validNumber(vipPlatinum) || !validNumber(vipSappphire) ||
                !validNumber(top1) || !validNumber(top2) || !validNumber(top3) || 
                !validNumber(top4) || !validNumber(top5) || !validNumber(top6) || 
                !validNumber(top7) || !validNumber(top8) || !validNumber(top9) || 
                !validNumber(top10) || !validNumber(multiple)
            ) {
                showError("Vui lòng nhập số hợp lệ");
                return;
            }

            const body = {
                config: {
                    vipLevels: {
                        NEW: vipNew ? 
                            { MAX_SCORE: vipNew, BOMB_RATE: configGame?.vipNew.BOMB_RATE, PERSON_RATE: configGame?.vipNew.PERSON_RATE } : 
                            configGame?.vipNew,
                        NORMAL: vipNew ? 
                            { MAX_SCORE: vipNew, BOMB_RATE: configGame?.vipNew.BOMB_RATE, PERSON_RATE: configGame?.vipNew.PERSON_RATE } : 
                            configGame?.vipNew,
                        COPPER: vipNew ? 
                            { MAX_SCORE: vipNew, BOMB_RATE: configGame?.vipNew.BOMB_RATE, PERSON_RATE: configGame?.vipNew.PERSON_RATE } : 
                            configGame?.vipNew,
                        SILVER: vipSilver ? 
                            { MAX_SCORE: vipSilver, BOMB_RATE: configGame?.vipSilver.BOMB_RATE, PERSON_RATE: configGame?.vipNew.PERSON_RATE } : 
                            configGame?.vipSilver,
                        GOLD: vipSilver ? 
                            { MAX_SCORE: vipSilver, BOMB_RATE: configGame?.vipSilver.BOMB_RATE, PERSON_RATE: configGame?.vipNew.PERSON_RATE } : 
                            configGame?.vipSilver,
                        PLATINUM: vipPlatinum ? 
                            { MAX_SCORE: vipPlatinum, BOMB_RATE: configGame?.vipPlatinum.BOMB_RATE, PERSON_RATE: configGame?.vipNew.PERSON_RATE } : 
                            configGame?.vipPlatinum,
                        EMERALD: vipPlatinum ? 
                            { MAX_SCORE: vipPlatinum, BOMB_RATE: configGame?.vipPlatinum.BOMB_RATE, PERSON_RATE: configGame?.vipNew.PERSON_RATE } : 
                            configGame?.vipPlatinum,
                        SAPPHIRE: vipSappphire ? 
                            { MAX_SCORE: vipSappphire, BOMB_RATE: configGame?.vipSappphire.BOMB_RATE, PERSON_RATE: configGame?.vipNew.PERSON_RATE } : 
                            configGame?.vipSappphire,
                        DIAMOND: vipSappphire ? 
                            { MAX_SCORE: vipSappphire, BOMB_RATE: configGame?.vipSappphire.BOMB_RATE, PERSON_RATE: configGame?.vipNew.PERSON_RATE } : 
                            configGame?.vipSappphire,
                    },
                    eventRewards: {
                        "TOP1": top1 ? top1 : configGame?.top1,
                        "TOP2": top2 ? top2 : configGame?.top2,
                        "TOP3": top3 ? top3 : configGame?.top3,
                        "TOP4": top4 ? top4 : configGame?.top4,
                        "TOP5": top5 ? top5 : configGame?.top5,
                        "TOP6": top6 ? top6 : configGame?.top6,
                        "TOP7": top7 ? top7 : configGame?.top7,
                        "TOP8": top8 ? top8 : configGame?.top8,
                        "TOP9": top9 ? top9 : configGame?.top9,
                        "TOP10": top10 ? top10 : configGame?.top10
                    },
                    multiple: Number(multiple ?? configGame?.multiple)
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
            setIsShowModalSuccess(true);
            await getDataConfig();
        } catch (err) {
            console.log(err);
            showError(err?.response?.data?.message || err?.data?.message || "Cập nhật thất bại");
        }
    };

    const validNumber = (value) => {
        if (value === undefined || value === null || value === "") {
            return false;
        }
        const number = parseInt(value);
        return !isNaN(number) && number > 0;
    }

    const showError = (errorMessage) => {
        messageApi.open({
        type: 'error',
        content: errorMessage,
        });
    };

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderInputNumer = (key, defaultValue, changeInput, max, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    <InputNumber
                        key={key}
                        style={{ width: "100%" }}
                        defaultValue={defaultValue}
                        onChange={changeInput}
                        max={max}
                        min={1}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            {configGame && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div style={{ fontWeight: 500 }}>Điểm Cao Nhất Trong Một Lượt Chơi</div>
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {configGame && renderInputNumer(
                                    "new",
                                    configGame?.vipNew.MAX_SCORE, 
                                    (e) => handleChangeInput(e, 1), 
                                    500, `${TEXT.vipLevel} NEW - COPPER`
                                )}

                                {renderInputNumer(
                                    "silver",
                                    configGame?.vipSilver.MAX_SCORE, 
                                    (e) => handleChangeInput(e, 2), 
                                    500, `${TEXT.vipLevel} SILVER - GOLD`
                                )}

                                {renderInputNumer(
                                    "platinum",
                                    configGame?.vipPlatinum.MAX_SCORE, 
                                    (e) => handleChangeInput(e, 3), 
                                    500, `${TEXT.vipLevel} PLATINUM - EMERALD`
                                )}

                                {renderInputNumer(
                                    "sapphire",
                                    configGame?.vipSappphire.MAX_SCORE, 
                                    (e) => handleChangeInput(e, 4), 
                                    500, `${TEXT.vipLevel} SAPPHIRE - DIAMOND`
                                )}
                            </div>

                            <div style={{ fontWeight: 900, margin: 20 }}>--------------------------------------------</div>
                            <div className="col-10 flex flex-col items-center justify-center">
                                <div className="flex w-full items-center mt-4">
                                    <div className="flex w-[20%] justify-end mr-10">{TEXT.multiple}:</div>
                                    <div className="w-[60%]">
                                        <InputNumber
                                            style={{ width: "100%" }}
                                            value={multiple}
                                            onChange={(val) => setMultiple(val)}
                                            max={999}
                                            min={1}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div style={{ fontWeight: 900, margin: 20 }}>--------------------------------------------</div>
                            <div style={{ fontWeight: 500 }}>Bảng Xếp Hạng</div>
                            <div className="col-10 flex flex-col items-center justify-center">
                                {configGame && renderInputNumer(
                                    "top1",
                                    configGame?.top1, 
                                    (e) => handleChangeInput(e, 5), 
                                    999, `TOP1`
                                )}

                                {renderInputNumer(
                                    "top2",
                                    configGame?.top2, 
                                    (e) => handleChangeInput(e, 6), 
                                    999, `TOP2`
                                )}

                                {renderInputNumer(
                                    "top3",
                                    configGame?.top3, 
                                    (e) => handleChangeInput(e, 7), 
                                    999, `TOP3`
                                )}

                                {renderInputNumer(
                                    "top4",
                                    configGame?.top4, 
                                    (e) => handleChangeInput(e, 8), 
                                    999, `TOP4`
                                )}

                                {configGame && renderInputNumer(
                                    "top5",
                                    configGame?.top5, 
                                    (e) => handleChangeInput(e, 9), 
                                    999, `TOP5`
                                )}

                                {renderInputNumer(
                                    "top6",
                                    configGame?.top6, 
                                    (e) => handleChangeInput(e, 10), 
                                    999, `TOP6`
                                )}

                                {renderInputNumer(
                                    "top7",
                                    configGame?.top7, 
                                    (e) => handleChangeInput(e, 11), 
                                    999, `TOP7`
                                )}

                                {renderInputNumer(
                                    "top8",
                                    configGame?.top8, 
                                    (e) => handleChangeInput(e, 12), 
                                    999, `TOP8`
                                )}

                                {renderInputNumer(
                                    "top9",
                                    configGame?.top9, 
                                    (e) => handleChangeInput(e, 13), 
                                    999, `TOP9`
                                )}

                                {renderInputNumer(
                                    "top10",
                                    configGame?.top10, 
                                    (e) => handleChangeInput(e, 14), 
                                    999, `TOP10`
                                )}
                            </div>

                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default SetupScore;
